module.exports = __webpack_public_path__ + "static/img/cp1.4ed0037e.png";